import { Cart } from "@commercetools/platform-sdk"
import { TFunction } from "i18next"
import { ErrorType } from "../../../error/ErrorType"
import { CartValidationBase, cartSuccess } from "../../validation/FormValidator"
import {
  CartValidationResult,
  cartError
} from "../../validation/ValidationError"

export class EmailValidation extends CartValidationBase {
  private readonly t: TFunction

  constructor(t: TFunction) {
    super("ValidateCustomerEmail")
    this.t = t
  }

  validate: (cart: Cart) => CartValidationResult = c => {
    if (!c?.customerEmail) {
      return cartError(ErrorType.CustomerInformationError, {
        title: this.t("checkout:emailAddress"),
        message: this.t("checkout:emailRequired")
      })
    }
    return cartSuccess(c)
  }
}
